import { Component, input, InputSignal } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../openapi';
import {
  AttachmentsDataPreviewComponent
} from '../attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { DatePipe } from '@angular/common';
import { LabelComponent } from '../../../../../common/label/label.component';
import { environment } from '../../../../../../environments/environment';
import { safeContentPipe } from '../../../../../pipes/safe-content.pipe';

@Component({
  selector: 'app-application-preview',
  standalone: true,
  imports: [
    AttachmentsDataPreviewComponent,
    DatePipe,
    LabelComponent,
    safeContentPipe
  ],
  templateUrl: './application-preview.component.html'
})
export class ApplicationPreviewComponent {
  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public env = environment;
}
